export default {
  myAssemble: {
    line: '我是有底线的',
    JoinTime: '参团时间',
    WaitingForGroup: '待成团',
    InProgress: '拼团中',
    GroupSuccess: '拼团成功',
    GroupFailure: '拼团失败',
    Specification: '规格',
    GroupPrice: '拼团价',
    PleasePay: '请在规定时间内付款，否则订单将自动取消',
    RemainingTime: '剩余时间',
    minute: '分',
    Second: '秒',
    PayNow: '立即支付',
    PeopleGroupOnlyNeed: '人成团，仅差',
    PeopleToComplete: '人拼成',
    OnlyLeft: '仅剩',
    End: '结束',
    InviteFriends: '邀请好友',
    please: '请在',
    PleaseInPersonal: '“个人中心”-“我的订单”',
    toview: '中查看',
    Restart: '重新发起',
    OopsNoOrderFound: '哎呀，没有相关订单呢～',
    All: '全部',
    ExceededPaymentTime: '超出支付时间！',
    GroupBuyingActivityEnded: '拼团活动结束！'
  }
}
